import React from "react";
import Marquee from "react-fast-marquee";
import { BRANDS } from "@/data/catalog";

export const BrandMarquee = () => {
  return (
    <section data-testid="brand-marquee" className="py-14 border-y border-white/10 bg-[#0A0A0B]">
      <Marquee speed={38} gradient gradientColor="#0A0A0B" gradientWidth={120} autoFill>
        {BRANDS.map((b, i) => (
          <span
            key={i}
            className="mx-8 sm:mx-12 font-display text-2xl sm:text-4xl font-medium text-white/25 hover:text-[#D4AF37]/70 transition-colors whitespace-nowrap"
          >
            {b}
          </span>
        ))}
      </Marquee>
    </section>
  );
};
